// appSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
const apiUrl = process.env.REACT_APP_API_URL;
const defaultTimeZone = typeof window !== 'undefined'
  ? window.localStorage.getItem('timeZone') || 'Asia/Kolkata'
  : 'Asia/Kolkata';

const persistedClientId = typeof window !== 'undefined' ? window.localStorage.getItem('clientId') || '' : '';
const persistedFinancialYear = typeof window !== 'undefined' ? window.localStorage.getItem('financialYear') || '' : '';
export const fetchExpenses = createAsyncThunk(
  'app/fetchExpenses',
  async (_, { getState }) => {
    const { clientId, financialYear } = getState().app;
    const response = await fetch(`${apiUrl}/api/expenses?clientId=${clientId}&financialYear=${financialYear}`);
    return response.json();
  }
);

const appSlice = createSlice({
  name: 'app',
  initialState: {
    clientId: persistedClientId,
    financialYear: persistedFinancialYear,
    expenses: [],
    loading: false,
    error: '',
    timeZone: defaultTimeZone,
  },
  reducers: {
    setClientId: (state, action) => {
      state.clientId = action.payload;
      if (typeof window !== 'undefined') {
        if (action.payload) window.localStorage.setItem('clientId', action.payload);
        else window.localStorage.removeItem('clientId');
      }
    },
    setFinancialYear: (state, action) => {
      state.financialYear = action.payload;
      if (typeof window !== 'undefined') {
        if (action.payload) window.localStorage.setItem('financialYear', action.payload);
        else window.localStorage.removeItem('financialYear');
      }
    },
    setTimeZone: (state, action) => {
      state.timeZone = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchExpenses.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(fetchExpenses.fulfilled, (state, action) => {
        state.expenses = action.payload;
        state.loading = false;
      })
      .addCase(fetchExpenses.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      });
  },
});

export const { setClientId, setFinancialYear, setTimeZone } = appSlice.actions;
export default appSlice.reducer;
